<template>
  <q-panel :header-text="formStructure.caption">
    <q-form
      :ref="formStructure.key"
      class="q-detail-form"
      :model="model"
      :rules="rangeRules"
      label-width="120px"
    >
      <q-form-generator
        v-model="model"
        :form-structure="formStructure"
      />
    </q-form>

    <div
      v-show="!readonly"
      slot="footer"
    >
      <q-button
        type="primary"
        @click="persist()"
      >
        <span>{{ $qt('model.okButtonText') }}</span>
      </q-button>
      <q-button
        v-show="!readonly"
        @click="reject()"
      >
        <span>{{ $qt('model.rejectButtonText') }}</span>
      </q-button>
      <q-button
        v-show="!readonly"
        type="danger"
        @click="deleteModel()"
      >
        <span>{{ $qt('model.deleteButtonText') }}</span>
      </q-button>
    </div>

    <q-dialog
      :title="this.$qt('model.deleteDialog.title')"
      width="30%"
      :visible.sync="deleteDialogVisible"
    >
      <span>{{ $qt('model.deleteDialog.warningNote') }}</span>
      <span slot="footer">
        <q-button
          type="danger"
          @click="deleteModel"
        >
          {{ $qt('model.deleteDialog.confirm') }}
        </q-button>
        <q-button
          type="inverse"
          @click="deleteDialogVisible = false"
        >
          {{ $qt('model.deleteDialog.cancel') }}
        </q-button>
      </span>
    </q-dialog>
  </q-panel>
</template>

<script>

  import caller from '../../../q-components/q-caller';

  export default {
    name: "QModelDetail",

    components: {},

    props: {
      structureKey: {type: String, required: true},
      modelId: {type: String, default: null}
    },

    data() {
      return {
        formStructure: {},

        readonly: false,
        deleteDialogVisible: false,

        title: '',
        message: {},
        model: {},

        detailDialog: false,
        currentModel: undefined,
        compositeRules: {}
      }
    },

    computed: {
      rangeRules() {
        let rules = {};
        if (this.formStructure === undefined || this.formStructure === null)
          return rules;

        for (let f in this.formStructure.properties) {
          let _field = this.formStructure.properties[f];
          let _rules = _field.rules;
          let fieldRules = [];
          for (let r in _rules) {
            fieldRules.push(_rules[r])
          }

          rules[_field.key] = fieldRules;
        }

        return rules;
      }
    },

    methods: {
      initialize(structureKey, modelId) {
        caller.delegate('structure', 'fetchFormStructure', {
          structureKey: structureKey
        }).then((res1) => {
          let structure = res1.result;
          let method = structure.method;
          if (!method)
            method = 'getEditable';
          caller.service(structure.plugin, structure.model, method, {
            modelId: modelId
          }).then((res) => {
            this.formStructure = structure;
            this.message = res.message;
            this.title = '';//this.$tools.findKey(this.message.elements, 'MODEL').value;
            this.model = res.result.model;

            if (this.model.id) {
              this.$notify({
                title: this.$qt('model.reservationMessageTitle'),
                message: this.message,
                type: 'success'
              });
            }

            this.$eventHub.$emit("onPageChanging", {
              caption: this.formStructure.caption,
              note: this.formStructure.note
            })
          }).catch(() => {
          });
        }).catch(() => {
        });
      },

      persist() {
        this.$refs[this.formStructure.key].validate((valid) => {
          if (valid) {
            this.$service(this.formStructure.plugin, this.formStructure.model, 'persist', {
              model: this.model
            }).then((result) => {
              this.$notify({
                title: this.$qt('model.successPersistTitle'),
                message: result.message,
                type: 'success'
              });
              this.readonly = true;
            }).catch(() => {
            });
          } else {
            this.$notify({
              title: this.$qt('notify.exceptionTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'success'
            });
            return false;
          }
        });
      },
      reject() {
        this.$service(this.formStructure.plugin, this.formStructure.model, 'reject', {
          modelId: this.model.id
        }).then((result) => {
          this.$notify({
            title: this.$qt('model.rejectedMessage'),
            message: result.message,
            type: 'success'
          });
          this.readonly = true;
        }).catch(() => {
        });
      },
      deleteModel() {
        this.$service(this.formStructure.plugin, this.formStructure.model, 'delete', {
          selectedModels: [this.model]
        }).then((result) => {
          this.$notify({
            title: this.$qt('model.deleteDialog.successMessage'),
            message: result.message,
            type: 'success'
          });
          this.readonly = true;
        }).catch(() => {
        });
      },
    },

    beforeRouteEnter(to, from, next) {

      next(vm => vm.initialize(
        to.params.structureKey,
        to.params.modelId === 'NEW' ? null : to.params.modelId
      ));

    },
    beforeRouteUpdate(to, from, next) {

      this.initialize(
        to.params.structureKey,
        to.params.modelId === 'NEW' ? null : to.params.modelId
      );
      next(vm => vm.initialize(
        to.params.structureKey,
        to.params.modelId === 'NEW' ? null : to.params.modelId
      ));

    }
  }
</script>

<style scoped>
  .q-detail-form {
    padding: 10px;
  }
</style>